import React from 'react';
import styled from 'astroturf/react';
import { PopoverMode, PopoverProps } from './Popover';
import { Menu } from './Menu';

const TooltipContainer = styled.div`
  padding: 4px 8px;
`;

/**
 * A basic tooltip component with Academia styling. This component uses
 * {@link Menu} as its parent, adding some additional styling.
 *
 * ## Basic Usage
 *
 * @example
 *
 * ```tsx
 * import { Tooltip } from 'js/design_system/Tooltip';
 *
 * <Tooltip
 *   render={() => <p>I'm the tooltip content!</p>}
 * >
 *   <p>Click me to activate!</p>
 * </Tooltip>
 * ```
 */
export const Tooltip: React.FC<PopoverProps> = ({
  mode = PopoverMode.Hover,
  placement = 'top',
  offset = 4,
  closeOnClick = false,
  popoverRef,
  render,
  children,
  ...props
}) => {
  return (
    <Menu
      mode={mode}
      placement={placement}
      offset={offset}
      closeOnClick={closeOnClick}
      render={() => {
        return <TooltipContainer ref={popoverRef}>{render()}</TooltipContainer>;
      }}
      {...props}
    >
      {children}
    </Menu>
  );
};
